var vars = require('./core');

module.exports = vars.createClass('Doughnut', ['getSegmentsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/doughnut.js
// module id = 1049
// module chunks = 0